import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  // Save data to local storage
  setItem(key: string, value: string | number | boolean | null): void {
    if (value === null || value === undefined) {
      return;
    }

    localStorage.setItem(key, JSON.stringify(value));
  }

  // Retrieve data from local storage (SAFE)
  getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);

    // handle missing or invalid values
    if (item === null || item === undefined || item === 'undefined') {
      return null;
    }

    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error(error);
      return item as unknown as T;
    }
  }

  // Remove data from local storage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all data from local storage
  clear(): void {
    localStorage.clear();
  }
}
